import { createSelector } from 'reselect';
import { NameSpace } from './enum';
import { getTariffBySales } from './helpers/selectorHelper';
import { SelectedOption } from './interface';
import { initialState } from './reducer';
import { RootState } from './types';

/*istanbul ignore next*/
const getAppState = (state: RootState) => state[NameSpace.APP] || initialState;

// 's' is always typed to StateProps thanks to getAppState
const selectAppState = createSelector(getAppState, s => s);
const selectError = createSelector(getAppState, s => s.error);
const selectSelectedOption = createSelector(getAppState, s => s.selectedOption);
const selectTariff = createSelector(getAppState, getTariffBySales);
const selectTariffs = createSelector(getAppState, s => s.tariffs);
const selectSalesChannel = createSelector(getAppState, s => s.salesChannel);

const selectSelectedSubLevelId = createSelector(getAppState, s => s.selectedOption.subscription.tariffId);
const selectSelectedHardwareId = createSelector(getAppState, s => s.selectedOption.hardwareId);

const selectDiscountIds = createSelector(selectSelectedOption, (selectedOption: SelectedOption) => {
    const discountIds = [];
    const dataVolumeIds = selectedOption?.subscription?.discount?.dataVolume?.map(discount => discount.id);
    const monetaryIds = selectedOption?.subscription?.discount?.monetary?.map(discount => discount.discountId);

    dataVolumeIds && discountIds.push(...dataVolumeIds);
    monetaryIds && discountIds.push(...monetaryIds);

    return discountIds;
});

export {
    selectAppState,
    selectError,
    selectSelectedOption,
    selectTariff,
    selectTariffs,
    selectSalesChannel,
    selectSelectedSubLevelId,
    selectSelectedHardwareId,
    selectDiscountIds,
};
